module.exports = __webpack_public_path__ + "img/pgn02.0786f197.png";